import { render } from "./App.vue?vue&type=template&id=e05848f4&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=e05848f4&lang=scss"

import exportComponent from "/codebuild/output/src4247593876/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__